import logo01 from './brand-logo-01.webp';
import logo02 from './brand-logo-02.webp';
import logo03 from './brand-logo-03.webp';
import logo04 from './brand-logo-04.webp';
import logo05 from './brand-logo-05.webp';
import logo06 from './brand-logo-06.webp';
import logo07 from './brand-logo-07.webp';
import logo08 from './brand-logo-08.webp';
import logo09 from './brand-logo-09.webp';
import logo10 from './brand-logo-10.webp';
import logo11 from './brand-logo-11.webp';
import logo12 from './brand-logo-12.webp';
import logo13 from './brand-logo-13.webp';
import logo14 from './brand-logo-14.webp';
import logo15 from './brand-logo-15.webp';
import logo16 from './brand-logo-16.webp';
import logo17 from './brand-logo-17.webp';
import logo18 from './brand-logo-18.webp';
import logo19 from './brand-logo-19.webp';
import logo20 from './brand-logo-20.webp';
import logo21 from './brand-logo-21.webp';
import logo22 from './brand-logo-22.webp';
import logo23 from './brand-logo-23.webp';
import logo24 from './brand-logo-24.webp';
import logo25 from './brand-logo-25.webp';
import logo26 from './brand-logo-26.webp';
import logo27 from './brand-logo-27.webp';
import logo28 from './brand-logo-28.webp';
import logo29 from './brand-logo-29.webp';
import logo30 from './brand-logo-30.webp';
import logo31 from './brand-logo-31.webp';
import logo32 from './brand-logo-32.webp';
import logo33 from './brand-logo-33.webp';
import logo34 from './brand-logo-34.webp';
import logo35 from './brand-logo-35.webp';
import logo36 from './brand-logo-36.webp';
import logo37 from './brand-logo-37.webp';
import logo38 from './brand-logo-38.webp';
import logo39 from './brand-logo-39.webp';

/** Shared brand logos from Figma `Group 2085661234` (node 179:5398), 2× WebP. */
export const BRAND_LOGOS = [
  logo01,
  logo02,
  logo03,
  logo04,
  logo05,
  logo06,
  logo07,
  logo08,
  logo09,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
  logo21,
  logo22,
  logo23,
  logo24,
  logo25,
  logo26,
  logo27,
  logo28,
  logo29,
  logo30,
  logo31,
  logo32,
  logo33,
  logo34,
  logo35,
  logo36,
  logo37,
  logo38,
  logo39,
] as const;

export const BRAND_LOGO_ROWS = [
  BRAND_LOGOS.slice(0, 13),
  BRAND_LOGOS.slice(13, 26),
  BRAND_LOGOS.slice(26, 39),
] as const;
